import { map, without, forEach, get, isEmpty, filter, includes } from 'lodash/fp';
import { WebsocketEventType, NotificationState } from '@mews-commander/legacy-data-structures';
import { fetchNotificationsByIds, markSeen, markPending } from './actions/common';
import { getNotificationIds } from './selectors';

export const notificationUpdatesHandler = {
    type: WebsocketEventType.NotificationUpdate,
    handle: (dispatch: $TSFixMe, getState: $TSFixMe, events: $TSFixMe) => {
        const notificationIds = getNotificationIds(getState());
        const incomingNotificationIds = map('entityId')(events);

        const unknownNotificationIds = without(notificationIds, incomingNotificationIds);
        if (!isEmpty(unknownNotificationIds)) {
            dispatch(fetchNotificationsByIds(unknownNotificationIds));
        }

        const knownNotificationEvents = filter((e) => !includes((e as $TSFixMe).entityId)(unknownNotificationIds))(
            events
        );
        forEach((e) => {
            const newState = get('data.state')(e);
            if (newState === NotificationState.Pending.name) {
                dispatch(markPending((e as $TSFixMe).entityId));
            }
            if (newState === NotificationState.Seen.name) {
                dispatch(markSeen((e as $TSFixMe).entityId));
            }
        })(knownNotificationEvents);
    },
};
